// Mapped to the DB

export const SectionType = {
    SUPPORT: 1,
    MONEY: 2,
    I_NEED_HELP_NOW: 3,
    ASSISTANT_SUPPORT : 4,
    ASSISTANT_NEED_HELP : 5,
    getPath: (type) => {
        switch (type) {
            case SectionType.SUPPORT:
                return "/support/";
            case SectionType.MONEY:
                return "/money/structure/";
            case SectionType.I_NEED_HELP_NOW:
                return "/needHelpNow/";
            case SectionType.ASSISTANT_SUPPORT:
            case SectionType.ASSISTANT_NEED_HELP:
                return "/plugin/support/";
            default:
                return "";
        }
    }
};

Object.freeze(SectionType);